import { render, staticRenderFns } from "./SectionInternship.vue?vue&type=template&id=0a2099d2&scoped=true&"
import script from "./SectionInternship.vue?vue&type=script&lang=js&"
export * from "./SectionInternship.vue?vue&type=script&lang=js&"
import style0 from "./SectionInternship.vue?vue&type=style&index=0&id=0a2099d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2099d2",
  null
  
)

export default component.exports